import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const onboardingSettingService = createApi({
  reducerPath: "onboardingSettingService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getOnboardingSettings: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: "/onboarding-settings",
        params,
        method: "GET",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    
    getOnboardingIntroduction: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: `/onboarding-introduction/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),

    getOnboardingSetting3ds: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: `/onboarding-setting-3ds/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    getOnboardingSettingBillingDetail: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: `/onboarding-setting-billing-detail/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    getOnboardingSettingCustomerVerification: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: `/onboarding-setting-customer-verification/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    getOnboardingSettingCongratulation: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: `/onboarding-setting-congratulation/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    getOnboardingSettingRequestCancellation: builder.mutation<any, { partner_id: number }>({
      query: (params) => ({
        url: `/onboarding-setting-request-cancellation/${params?.partner_id}`,
        params,
        method: "GET",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),

    updateOnboardingSettings: builder.mutation<any, any>({
      query: (body) => ({
        url: "/onboarding-settings",
        body: body,
        method: "PUT",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    uploadImage: builder.mutation<any, any>({
      query: (body) => ({
        url: `/info/uploadImage`,
        body: body,
        method: "POST",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    updateIntroduction: builder.mutation<any, { partner_id: number }>({
      query: (body) => ({
        url: `/onboarding-introduction/${body?.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    updateSetting3ds: builder.mutation<any, { partner_id: number }>({
      query: (body) => ({
        url: `/onboarding-setting-3ds/${body?.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    updateSettingBillingDetail: builder.mutation<any, { partner_id: number }>({
      query: (body) => ({
        url: `/onboarding-setting-billing-detail/${body?.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    updateSettingCustomerVerification: builder.mutation<any, { partner_id: number }>({
      query: (body) => ({
        url: `/onboarding-setting-customer-verification/${body?.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    updateSettingCongratulation: builder.mutation<any, { partner_id: number }>({
      query: (body) => ({
        url: `/onboarding-setting-congratulation/${body?.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
    updateSettingRequestCancellation: builder.mutation<any, { partner_id: number }>({
      query: (body) => ({
        url: `/onboarding-setting-request-cancellation/${body?.partner_id}`,
        body: body,
        method: "PUT",
        headers: {
          PageName: "Onboarding Settings",
        },
      }),
    }),
  }),
});

export const { useGetOnboardingSettingsMutation,
  useGetOnboardingIntroductionMutation,
  useGetOnboardingSetting3dsMutation,
  useGetOnboardingSettingBillingDetailMutation,
  useGetOnboardingSettingCustomerVerificationMutation,
  useGetOnboardingSettingCongratulationMutation,
  useGetOnboardingSettingRequestCancellationMutation,
  useUpdateOnboardingSettingsMutation,
  useUploadImageMutation,
  useUpdateIntroductionMutation,
  useUpdateSetting3dsMutation,
  useUpdateSettingBillingDetailMutation,
  useUpdateSettingCustomerVerificationMutation,
  useUpdateSettingCongratulationMutation,
  useUpdateSettingRequestCancellationMutation,
} = onboardingSettingService;
